import React, { useState, useEffect, useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { FaStarHalfAlt, FaStar, FaRegStar } from 'react-icons/fa';
import { IoMdArrowBack, IoMdArrowForward, IoIosInformationCircleOutline } from 'react-icons/io';
import { useGet } from '~hooks/useQuery';
import Stars from '~components/stars';
// import moment from 'moment';

import { isArray } from 'lodash';
import { Suspense } from '~components/suspense';
import ReviewsSkeleton from '~components/review/skeleton';
import { useIntl } from 'react-intl';

import { normalizeReviewScore } from './reviewScore';

import './style.scss';

const WorkerReviewCarousel = ({ isLoading, reviews }) => {
  const intl = useIntl();
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'start',
    loop: false,
    containScroll: 'trimSnaps',
    slidesToScroll: 1,
  });

  const [prevEnabled, setPrevEnabled] = useState(false);
  const [nextEnabled, setNextEnabled] = useState(false);

  const scrollPrev = useCallback(() => emblaApi?.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi?.scrollNext(), [emblaApi]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setPrevEnabled(emblaApi.canScrollPrev());
    setNextEnabled(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on('select', onSelect);
    onSelect();

    return () => {
      emblaApi.off('select', onSelect);
    };
  }, [emblaApi, onSelect]);

  return (
    <Suspense fallback={<ReviewsSkeleton />} isLoading={isLoading}>
      {reviews.length > 0 && (
        <div className="reviews">
          <h3>{intl.formatMessage({ id: 'containers.profile.worker.reviews', defaultMessage: 'Customer reviews' })}</h3>
          <div className="c__slider c_work-review-slider">
            <div className="c__slider__viewport" ref={emblaRef}>
              <div className="c__slider__container">
                {!reviews || !isArray(reviews) || reviews.length === 0
                  ? null
                  : reviews.map((review, index) => {
                      const reviewScore = normalizeReviewScore(review.score);

                      return (
                      <div className="c__slider__slide" key={review.id || index}>
                        <div className="review">
                          <div className="title">
                            {review.author_first_name === '[account-deleted]' ? (
                              <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                Anonymous
                                <IoIosInformationCircleOutline
                                  title="This user has removed their account."
                                  size={16}
                                  style={{ color: '#706767', cursor: 'help' }}
                                />
                              </span>
                            ) : (
                              review.author_first_name
                            )}
                          </div>

                          {reviewScore != null ? (
                            <div className="star-rating-show">
                              <div className="c-profile__score">
                                <Stars value={reviewScore} />
                              </div>
                              <div className="rate-number">{reviewScore}/5</div>
                            </div>
                          ) : null}

                          <div className="short-summery">{review.text || '-'}</div>
                          {/* <div className="date">
                            {review.created_at
                              ? intl.formatDate(moment.unix(review.created_at).toDate(), {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                })
                              : '-'}
                          </div> */}

                          {/* <div className="reply-area">
                            <h5>Reply from Jaquon</h5>
                            <div className="reply-description">Hi Kevin, thanks you so much hope to meet you soon. :-)</div>
                            <div className="date">09-08-2023</div>
                          </div> */}

                          {reviewScore != null ? (
                            <div itemProp="review" itemType="https://schema.org/Review" itemScope>
                              <div itemProp="author" itemType="https://schema.org/Person" itemScope>
                                <meta itemProp="name" content={review.author_first_name || 'Anonymous'} />
                              </div>
                              <div itemProp="reviewRating" itemType="https://schema.org/Rating" itemScope>
                                <meta itemProp="ratingValue" content={reviewScore} />
                                <meta itemProp="bestRating" content="5" />
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      );
                    })}
              </div>
            </div>

            {reviews.length > 1 && (
              <>
                <button type="button" className="c_slider__arrow c_slider__arrow--prev" onClick={scrollPrev} disabled={!prevEnabled} aria-label={intl.formatMessage({ id: 'components.worker-review-carousel.previous', defaultMessage: 'Previous review' })}>
                  <IoMdArrowBack />
                </button>
                <button type="button" className="c_slider__arrow c_slider__arrow--next" onClick={scrollNext} disabled={!nextEnabled} aria-label={intl.formatMessage({ id: 'components.worker-review-carousel.next', defaultMessage: 'Next review' })}>
                  <IoMdArrowForward />
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </Suspense>
  );
};

export default WorkerReviewCarousel;
